module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-114x114-56894419fcd1bd6510d5071f0e7c86dc.png";